import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { NgTagInputComponent } from './tag-input.component';
import { NgDialogsModule } from '../../dialogs';
import { NgEventAnimationModule } from '../../../animations';
import { NgDirectivesModule } from '../../../directives';
import { NgStylingComponentsModule } from '../../../styling-components';


@NgModule({
	declarations: [
		NgTagInputComponent
	],
	imports: [
		CommonModule,
		DragDropModule,
		NgDirectivesModule,
		FormsModule,
		NgDialogsModule,
		NgEventAnimationModule,
		NgStylingComponentsModule
	],
	exports: [
		NgTagInputComponent
	]
})
export class NgTagInputModule { }
